import { createFileRoute, redirect } from '@tanstack/react-router';

// Retired: the per-pond logbook grid is consolidated into the single adaptive
// entry surface (single-pond scope).
export const Route = createFileRoute('/_app/entry/pond/$pondId/water')({
  validateSearch: (search: Record<string, unknown>) => ({
    date: typeof search.date === 'string' ? search.date : undefined,
  }),
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/entry',
      search: { scope: 'single', pond: params.pondId, date: search.date },
    });
  },
});
